import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';

const NAV_LINKS = [
  { to: '/research', label: 'Research' },
  { to: '/bloora', label: 'Product' },
  { to: '/company', label: 'Company' },
];

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Close mobile drawer on route change
  useEffect(() => { setOpen(false); }, [location.pathname]);

  // Lock body scroll when drawer open
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => { document.body.style.overflow = ''; };
  }, [open]);

  return (
    <>
      <nav
        className={`fixed top-0 w-full z-50 transition-all duration-500 ${
          scrolled ? 'shadow-sm backdrop-blur-sm' : ''
        }`}
        style={{ backgroundColor: scrolled ? 'rgba(251, 252, 243, 0.95)' : '#fbfcf3' }}
      >
        <div className="max-w-6xl mx-auto px-6 py-4 flex justify-between items-center">
          <Link
            to="/"
            className="flex items-center space-x-1.5 hover:opacity-70 transition-opacity duration-300 font-display"
          >
            <img src="/logo_new_v2.png" alt="Cognitics" className="h-11 md:h-12 w-auto" />
            <span className="text-base md:text-lg font-normal tracking-[0.2em]">COGNITICS</span>
          </Link>

          {/* Desktop links */}
          <div className="hidden md:flex items-center space-x-8 text-sm">
            {NAV_LINKS.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `relative transition-colors duration-300 ${
                    isActive ? 'text-gray-900' : 'text-gray-500 hover:text-gray-900'
                  }`
                }
              >
                {({ isActive }) => (
                  <>
                    {label}
                    {isActive && (
                      <span className="absolute -bottom-1 left-0 w-full h-px bg-gray-900" />
                    )}
                  </>
                )}
              </NavLink>
            ))}
            <Link
              to="/bloora"
              className="relative ml-2 inline-flex items-center pl-5 pr-7 py-2 bg-gray-900 text-white text-sm hover:bg-gray-700 transition-colors duration-300"
            >
              Explore Bloora
              <svg
                aria-hidden="true"
                viewBox="0 0 16 16"
                className="absolute top-1.5 right-1.5 w-3 h-3"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.75"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <line x1="4" y1="12" x2="12" y2="4" />
                <polyline points="6 4 12 4 12 10" />
              </svg>
            </Link>
          </div>

          {/* Mobile hamburger */}
          <button
            type="button"
            aria-label="Open menu"
            aria-expanded={open}
            onClick={() => setOpen((v) => !v)}
            className="md:hidden w-11 h-11 flex flex-col items-center justify-center space-y-1.5 bg-transparent border-0 p-0"
          >
            <span className={`block w-6 h-px bg-gray-900 transition-transform duration-300 ${open ? 'translate-y-2 rotate-45' : ''}`} />
            <span className={`block w-6 h-px bg-gray-900 transition-opacity duration-300 ${open ? 'opacity-0' : ''}`} />
            <span className={`block w-6 h-px bg-gray-900 transition-transform duration-300 ${open ? '-translate-y-2 -rotate-45' : ''}`} />
          </button>
        </div>
      </nav>

      {/* Mobile drawer */}
      <div
        className={`md:hidden fixed inset-0 z-40 transition-opacity duration-300 ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'
        }`}
        style={{ backgroundColor: '#fbfcf3' }}
      >
        <div className="pt-28 px-6 pb-10 h-full flex flex-col">
          <div className="flex-1 flex flex-col space-y-6">
            {NAV_LINKS.map(({ to, label }) => (
              <NavLink
                key={to}
                to={to}
                className={({ isActive }) =>
                  `text-3xl font-light min-h-[44px] flex items-center ${
                    isActive ? 'text-gray-900' : 'text-gray-500'
                  }`
                }
              >
                {label}
              </NavLink>
            ))}
          </div>
          <Link
            to="/bloora"
            className="relative w-full inline-flex items-center justify-center py-4 bg-gray-900 text-white text-base hover:bg-gray-700 transition-colors duration-300"
          >
            Explore Bloora
            <svg
              aria-hidden="true"
              viewBox="0 0 16 16"
              className="absolute top-2 right-2 w-3.5 h-3.5"
              fill="none"
              stroke="currentColor"
              strokeWidth="1.75"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <line x1="4" y1="12" x2="12" y2="4" />
              <polyline points="6 4 12 4 12 10" />
            </svg>
          </Link>
        </div>
      </div>
    </>
  );
}
